<template>
  <div class="w-full">
    <div class="flex items-center justify-between my-3">
      <span class="text-sm font-niceone-medium">
        {{ $t('product.reviews.comments', {length: comments.length}) }}
      </span>
    </div>
    <van-cell-group>
      <niceone-field v-model="comment" :placeholder="$t('product.reviews.write_a_comment')"
                     class="rounded-md !bg-cultured !p-0 !ps-3"
                     clearable>
        <template #button>
          <van-button :loading="isLoading"
                      class="!h-10 !bg-secondary-light font-niceone-medium !h-10 !text-secondary !border-none"
                      type="primary" @click="onSubmit">
            {{ $t('common.send') }}
          </van-button>
        </template>
      </niceone-field>
    </van-cell-group>
    <div class="flex-center text-secondary pt-3">
      <van-icon class="cursor-pointer" name="arrow-up" size="20" @click="emit('hide')"/>
    </div>
    <review-reply-list v-for="(review,index) in comments" :key="`review-list-item-${index}`" :review="review"/>
  </div>
</template>

<script setup>
import ReviewReplyList from '@/components/product/reviews/ReviewReplyList'
import {addComments} from "@/plugins/API/review"
import {useAuthStore} from "@/store/auth";
import {NOTIFICATION_ERROR_TYPES} from "~/constants";
import {useEventBus} from "@vueuse/core";
import {EVENTS, TRACKERS} from "~/constants/events";
import {track} from "@/composables/useTrackEvent";

const authStore = useAuthStore();
const {isLoggedIn} = storeToRefs(authStore);
const props = defineProps({
  comments: {
    type: Array,
    default: []
  },
  review: {
    type: Object,
    default: {}
  },
  product: {
    type: Object,
    default: {}
  },
  index: {
    type: Number,
    default: 0
  }
})
const emit = defineEmits(['toggleReviewBox', 'updateSubLike', 'hide'])
const {emit: emitAuth} = useEventBus(EVENTS.AUTH_DIALOG);
const comment = ref('');
const {isLoading, mutateAsync: addCommentsMutateAsync} = addComments();
const onSubmit = () => {
  if (isLoggedIn.value) {
    addCommentsMutateAsync({text: comment.value, review_id: props.review.review_id}).then(({data}) => {
      showNotification({
        type: NOTIFICATION_ERROR_TYPES.SUCCESS, messages: data.message
      });
      comment.value = '';
      track(TRACKERS.REVIEW_LIKE_COMMENT, {
        type: 'comment',
        product: props.product
      })
    });
  } else {
    emitAuth({redirection: false})
  }
}
</script>

<style lang="scss" scoped>

</style>